import { useResponsiveContext } from "./ResponsiveContext.js";
var BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl'];
export function useCollapseBreakpoint(collapseBreakpoint) {
  var {
    breakpoint = 'xs'
  } = useResponsiveContext();
  if (collapseBreakpoint == null) {
    return false;
  }
  var breakpointIDX = BREAKPOINTS.indexOf(breakpoint);
  var collapseBreakpointIDX = BREAKPOINTS.indexOf(collapseBreakpoint);
  return breakpointIDX < collapseBreakpointIDX;
}